module.exports = __webpack_public_path__ + "static/img/4.b34fe92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/4.png
// module id = B/4l
// module chunks = 35